module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select":"Select ...","price":"Price"},"ar":{"select":"أختر ...","price":"السعر"}}')
  delete Component.options._Ctor
}
